import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { withSagas } from 'decorators/Sagas';
import { decorateWith } from 'helpers/decorator';
import { msas } from 'redux/saga/entities/bound';
import { selectMsaId } from 'redux/modules/features/homepage';
import { msaById } from 'redux/saga/selectors/msas';
import { LocationInputContainer } from 'components/LocationInput/LocationInputContainer';
import { updateSelectedOffer } from '../ProductGroup/sagas/product.saga';
import { loadSaga, watchSaga, changeLocation } from './location-selector.saga';

const messages = defineMessages({
  locationLeadIn: {
    id: 'location-selector.label',
    defaultMessage: 'I’m in',
  },
  locationPlaceholder: {
    id: 'location-selector.placeholder',
    defaultMessage: ' enter city name',
  },
});

export class LocationSelectorUnwrapped extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }

  handleLocationChange(loc) {
    if (loc) {
      const { lat, lon, name } = loc;
      this.props.onChangeLocation(lat, lon, name);
      this.props.updateSelectedOffer({});
    }
  }

  render() {
    const { label, locationName, intl } = this.props;

    return (
      <LocationInputContainer
        initialValue={locationName}
        inputAttributes={{ placeholder: intl.formatMessage(messages.locationPlaceholder) }}
        label={label || intl.formatMessage(messages.locationLeadIn)}
        onChange={this.handleLocationChange}
        style="underlined"
      />
    );
  }
}

LocationSelectorUnwrapped.propTypes = {
  label: PropTypes.string,
  locationName: PropTypes.string,
  onChangeLocation: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  updateSelectedOffer: PropTypes.func.isRequired,
};

export const mapStateToProps = state => {
  const msa = msaById(msas.data(state), selectMsaId(state)) || {};
  return {
    locationName: msa.city || msa.name || '',
  };
};

export const mapDispatchToProps = {
  onChangeLocation: changeLocation,
  updateSelectedOffer,
};

export const LocationSelector = decorateWith(
  injectIntl,
  withSagas({ load: loadSaga, watch: watchSaga }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LocationSelectorUnwrapped);
